import { Component, Input, OnInit } from '@angular/core';
import { ChargebeePartnerDiscountCode } from '../../models/partner-discount-code';
import { PartnersService } from '../../services/partners.service';

@Component({
  standalone: false,
  selector: 'sbnb-partner-discount-details-banner',
  templateUrl: './partner-discount-details-banner.component.html',
  styleUrls: ['./partner-discount-details-banner.component.scss'],
})
export class PartnerDiscountDetailsBannerComponent implements OnInit {
  @Input() code: string;
  coupon: ChargebeePartnerDiscountCode | null = null;
  error: string | null = null;
  loading: boolean = true;

  constructor(private partnerService: PartnersService) { }

  ngOnInit(): void {
    this.loading = true;
    if (!this.code) {
      this.error = 'No code provided';
      return;
    }

    this.partnerService.fetchPartnerDiscountCode(this.code).subscribe((res) => {
      if ('id' in res) {
        this.coupon = res as ChargebeePartnerDiscountCode;
      }
      this.loading = false;
      this.error = (res as any).error;
    });
  }
}
